import React from 'react';

const PaymentMethodSelector = ({ selectedMethod, onSelect }) => {
  return (
    <div className="payment-method-selector">
      <h3>Select Payment Method</h3>
      <div className="method-options">
        <label>
          <input
            type="radio"
            value="card"
            checked={selectedMethod === 'card'}
            onChange={() => onSelect('card')}
          />
          Credit/Debit Card
        </label>
        <label>
          <input
            type="radio"
            value="bkash"
            checked={selectedMethod === 'bkash'}
            onChange={() => onSelect('bkash')}
          />
          bKash (Bangladesh)
        </label>
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
